import React, { useState, useEffect } from "react";
import "../Styles/BookingFormModal.css";
import { client } from "../sanity"; // import sanity client

const BookingFormModal = ({ show, onClose, prefill = {}, includeCarName = true }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    tripType: "",
    carName: includeCarName ? prefill.carName || "" : "",
    date: "",
    time: "",
    passengers: "",
    specialRequest: "",
    pickup: "",
    dropoff: "",
  });

  const [carsInCategory, setCarsInCategory] = useState([]);

  // Fetch all cars in the same category as the prefill car
  useEffect(() => {
    const fetchCarsByCategory = async () => {
      if (!includeCarName || !prefill.carName) return;

      try {
        // Fetch the prefill car details to get its category
        const carData = await client.fetch(
          `*[_type == "vehicle" && name == $carName][0]{ name, category }`,
          { carName: prefill.carName }
        );

        if (carData?.category) {
          const categoryCars = await client.fetch(
            `*[_type == "vehicle" && category == $category]{ name }`,
            { category: carData.category }
          );
          setCarsInCategory(categoryCars);
        }
      } catch (error) {
        console.error("Error fetching cars for dropdown:", error);
      }
    };

    fetchCarsByCategory();
  }, [prefill.carName, includeCarName]);

  // Sync prefill data whenever modal opens
  useEffect(() => {
    if (show) {
      setFormData((prev) => ({
        ...prev,
        pickup: prefill.pickup || "",
        dropoff: prefill.dropoff || "",
        date: prefill.date || "",
        time: prefill.time || "",
        carName: includeCarName ? prefill.carName || "" : "",
      }));
    }
  }, [prefill, show, includeCarName]);

  if (!show) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const message = `
🚗 *New Ride Booking Request*
------------------------------
👤 Name: ${formData.name}
📧 Email: ${formData.email}
📞 Phone: ${formData.phone}
🛣 Trip Type: ${formData.tripType}
📍 Pickup: ${formData.pickup}
🏁 Dropoff: ${formData.dropoff}
📅 Date: ${formData.date}
⏰ Time: ${formData.time}
👥 Passengers: ${formData.passengers}
${includeCarName ? `🚘 Car: ${formData.carName}` : ""}
📝 Special Request: ${formData.specialRequest}
    `.trim();

    const phoneNumber = "2347030792420"; // WhatsApp number
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");

    onClose();
  };

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{ animation: show ? "fadeIn 0.4s ease forwards" : "fadeOut 0.3s ease forwards" }}
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Book Your Ride</h2>
        <form className="booking-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <input type="text" name="name" placeholder="Name" required value={formData.name} onChange={handleChange} />
            <input type="email" name="email" placeholder="Email" required value={formData.email} onChange={handleChange} />
          </div>

          <div className="form-row">
            <input type="tel" name="phone" placeholder="Phone" required value={formData.phone} onChange={handleChange} />
            <div className="select-wrapper">
              <select name="tripType" required value={formData.tripType} onChange={handleChange}>
                <option value="">Trip Type</option>
                <option value="oneway">One Way</option>
                <option value="roundtrip">Round Trip</option>
                <option value="hourly">Hourly</option>
                <option value="hourly">Inter-State</option>
              </select>
              <span className="dropdown-arrow">▼</span>
            </div>
          </div>

          {includeCarName && (
            <div className="form-row">
              <div className="select-wrapper">
                <select name="carName" required value={formData.carName} onChange={handleChange}>
                  <option value="">Select Car</option>
                  {carsInCategory.map((car, idx) => (
                    <option key={idx} value={car.name}>
                      {car.name}
                    </option>
                  ))}
                </select>
                <span className="dropdown-arrow">▼</span>
              </div>
            </div>
          )}

          <div className="form-row">
            <input type="text" name="pickup" placeholder="Pickup Location" value={formData.pickup} onChange={handleChange} />
            <input type="text" name="dropoff" placeholder="Drop-off Location" value={formData.dropoff} onChange={handleChange} />
          </div>

          <div className="form-row">
            <input type="date" name="date" required value={formData.date} onChange={handleChange} />
            <div className="time-wrapper">
              <input type="time" name="time" id="pickup-time" required value={formData.time} onChange={handleChange} />
              <label htmlFor="pickup-time">Choose Pickup Time</label>
            </div>
            <input type="number" name="passengers" placeholder="No. Of Passengers" min="1" required value={formData.passengers} onChange={handleChange} />
          </div>

          <textarea name="specialRequest" placeholder="Special Request" value={formData.specialRequest} onChange={handleChange}></textarea>

          <button type="submit">
            <span className="plus-icon">+</span> Book Now
          </button>
        </form>
      </div>
    </div>
  );
};

export default BookingFormModal;
